export const DELIVERY_ERROR = "DELIVERY_ERROR";
export const DELIVERY_RESET = "DELIVERY_RESET";
export const GET_DELIVERY = "GET_DELIVERY";
export const GET_DELIVERY_CONTACT = "GET_DELIVERY_CONTACT";
export const EDIT_DELIVERY_SUCCESS = "EDIT_DELIVERY_SUCCESS";
export const CREATE_DELIVERY_SUCCESS = "CREATE_DELIVERY_SUCCESS";
export const CREATE_DELIVERY_FAILED = "CREATE_DELIVERY_FAILED";
export const EDIT_DELIVERY_FAILED = "EDIT_DELIVERY_FAILED";
export const CREATE_DELIVERY_PENDING = "CREATE_DELIVERY_PENDING";
